(function () {
  const ROOT_SEL = "[data-intro-root]";

  function waitForGSAP(cb) {
    const start = Date.now();
    (function tick() {
      if (window.gsap) return cb(true);
      if (Date.now() - start > 4500) return cb(false);
      setTimeout(tick, 50);
    })();
  }

  function lockScroll() {
    document.documentElement.classList.add("IntroSplash--lock");
    document.body.classList.add("IntroSplash--lock");
  }
  function unlockScroll() {
    document.documentElement.classList.remove("IntroSplash--lock");
    document.body.classList.remove("IntroSplash--lock");
  }

  function getTtlMs(freq) {
    if (freq === "day") return 24 * 60 * 60 * 1000;
    if (freq === "week") return 7 * 24 * 60 * 60 * 1000;
    return 0;
  }

  function initRoot(root) {
    if (!root || root.__intro_inited) return;
    root.__intro_inited = true;

    const debug = root.getAttribute("data-debug") === "true";
    const testMode = root.getAttribute("data-test-mode") === "true";
    const freq = root.getAttribute("data-frekans") || "session";
    const durationMs = Number(root.getAttribute("data-sure")) || 3000;

    const bgEnabled = root.getAttribute("data-bg-particles") === "true";
    const bgCount = Math.max(0, Math.min(200, Number(root.getAttribute("data-bg-particles-count")) || 45));

    const dustEnabled = root.getAttribute("data-loading-dust") === "true";
    const dustIntensity = Math.max(0, Math.min(24, Number(root.getAttribute("data-loading-dust-intensity")) || 10));
    const dustSize = Math.max(2, Math.min(12, Number(root.getAttribute("data-loading-dust-size")) || 5));

    const sectionId = root.getAttribute("data-section-id") || "default";
    const seenKey = "intro_seen_" + sectionId;
    const tsKey = "intro_ts_" + sectionId;

    const fxLayer = root.querySelector("[data-fx-layer]") || root;
    const uiLayer = root.querySelector("[data-ui-layer]") || root;

    function log(...args) { if (debug) console.log("[IntroSplash]", ...args); }

    // Gate showing (unless test mode)
    if (!testMode) {
      if (freq === "session") {
        if (sessionStorage.getItem(seenKey) === "1") { root.remove(); return; }
      } else if (freq === "day" || freq === "week") {
        const last = Number(localStorage.getItem(tsKey) || "0");
        const ttl = getTtlMs(freq);
        if (last && Date.now() - last < ttl) { root.remove(); return; }
      }
    } else {
      log("Test mode ON");
    }

    const ambientGlow = root.querySelector("[data-ambient-glow]");
    const container = root.querySelector("[data-intro-container]");
    const brandName = root.querySelector("[data-brand-name]");
    const premiumRow = root.querySelector("[data-premium-row]");
    const lines = root.querySelectorAll(".IntroSplash__line");
    const loadingText = root.querySelector("[data-loading-text]");

    const loadingFill = root.querySelector("[data-loading-bar]");
    const loadingBarWrap = root.querySelector(".IntroSplash__loadingBar");
    const percentage = root.querySelector("[data-percentage]");
    const skipBtn = root.querySelector("[data-skip-btn]");

    if (brandName) brandName.setAttribute("data-text", brandName.textContent || "");

    function markSeen() {
      if (testMode) return;
      if (freq === "session") sessionStorage.setItem(seenKey, "1");
      if (freq === "day" || freq === "week") localStorage.setItem(tsKey, String(Date.now()));
    }

    function cleanup() { unlockScroll(); root.remove(); }

    // ---------- BACKGROUND PARTICLES (fxLayer) ----------
    function spawnBgParticles(gsap) {
      if (!bgEnabled || bgCount <= 0) return;

      fxLayer.innerHTML = ""; // sadece bu layer için temiz
      for (let i = 0; i < bgCount; i++) {
        const p = document.createElement("div");
        p.className = "IntroSplash__bgParticle";
        p.style.left = (Math.random() * 100) + "%";
        p.style.top = (Math.random() * 100) + "%";
        fxLayer.appendChild(p);

        const driftX = (Math.random() - 0.5) * 120;
        const driftY = (Math.random() - 0.5) * 120;
        const dur = 6 + Math.random() * 10;
        const delay = Math.random() * 2;

        gsap.set(p, { opacity: 0, scale: 0.8 + Math.random() * 1.2 });
        gsap.to(p, {
          opacity: 0.6,
          duration: 1.2,
          delay,
          ease: "power2.out"
        });

        gsap.to(p, {
          x: "+=" + driftX,
          y: "+=" + driftY,
          duration: dur,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut"
        });

        gsap.to(p, {
          opacity: 0.2 + Math.random() * 0.5,
          duration: 2 + Math.random() * 3,
          repeat: -1,
          yoyo: true,
          ease: "sine.inOut"
        });
      }
    }

    // ---------- UI PARTICLES (uiLayer): tip spark + dust burst ----------
    function createTipSpark(gsap, x, y) {
      const p = document.createElement("div");
      p.className = "IntroSplash__lightParticle";
      p.style.left = x + "px";
      p.style.top = y + "px";
      uiLayer.appendChild(p);

      gsap.set(p, { opacity: 1, scale: 1 });
      gsap.to(p, {
        x: "+=" + ((Math.random() - 0.5) * 140),
        y: "+=" + (-40 - Math.random() * 90),
        opacity: 0,
        duration: 0.55,
        ease: "power2.out",
        onComplete: () => p.remove()
      });
    }

    function createDustBurst(gsap, x, y) {
      if (!dustEnabled || dustIntensity <= 0) return;

      for (let i = 0; i < dustIntensity; i++) {
        const d = document.createElement("div");
        d.className = "IntroSplash__loadingDust";
        d.style.left = x + "px";
        d.style.top = y + "px";
        d.style.width = dustSize + "px";
        d.style.height = dustSize + "px";

        if (Math.random() < 0.35) {
          d.style.background = "rgba(255,255,255,0.95)";
          d.style.boxShadow = "0 0 14px rgba(255,255,255,0.6), 0 0 26px rgba(212,175,55,0.35)";
        }

        uiLayer.appendChild(d);

        const dx = (Math.random() - 0.5) * 260;
        const dy = -20 - Math.random() * 200;
        const s = 0.7 + Math.random() * 1.6;
        const dur = 0.45 + Math.random() * 0.7;

        gsap.set(d, { opacity: 1, scale: s });
        gsap.to(d, {
          x: dx,
          y: dy,
          opacity: 0,
          duration: dur,
          ease: "power2.out",
          onComplete: () => d.remove()
        });
      }
    }

    // GSAP glow inside fill (shimmer)
    let loadingGlow = null;
    if (loadingFill) {
      loadingGlow = document.createElement("div");
      loadingGlow.className = "IntroSplash__loadingGlow";
      loadingFill.appendChild(loadingGlow);
    }

    lockScroll();

    waitForGSAP((ok) => {
      if (!ok || !window.gsap) {
        // fallback
        markSeen();
        root.style.opacity = "1";
        setTimeout(() => {
          root.style.transition = "opacity 300ms ease";
          root.style.opacity = "0";
          setTimeout(cleanup, 350);
        }, 700);
        return;
      }

      const gsap = window.gsap;

      // spawn atmosphere particles
      spawnBgParticles(gsap);

      // initial states
      gsap.set(ambientGlow, { opacity: 0 });
      gsap.set(brandName, { opacity: 0, y: 30, filter: "blur(10px)" });
      gsap.set(premiumRow, { opacity: 0, y: 6 });
      gsap.set(lines, { opacity: 0, width: 0 });
      gsap.set(loadingText, { opacity: 0 });
      gsap.set(percentage, { opacity: 0 });
      if (loadingFill) gsap.set(loadingFill, { width: "0%" });
      if (loadingGlow) gsap.set(loadingGlow, { opacity: 0, x: 0 });
      gsap.set(container, { opacity: 1 });

      const progressObj = { value: 0 };

      function finish() { markSeen(); cleanup(); }

      const tl = gsap.timeline({ onComplete: finish });

      tl.to(ambientGlow, { opacity: 1, duration: 1.5, ease: "power2.out" });

      tl.to(brandName, {
        opacity: 1,
        y: 0,
        filter: "blur(0px)",
        duration: 1.8,
        ease: "power3.out",
        onStart: () => {
          setTimeout(() => { try { brandName.classList.add("shine"); } catch(e){} }, 500);
        }
      }, "-=1");

      tl.to(premiumRow, { opacity: 1, y: 0, duration: 1.0, ease: "power2.out" }, "-=0.9");
      tl.to(lines, { opacity: 1, width: 80, duration: 1.2, ease: "power2.out" }, "-=0.9");

      tl.to(loadingText, { opacity: 1, duration: 0.8 }, "-=0.5");
      tl.to(percentage, { opacity: 1, duration: 0.8 }, "-=0.6");

      // progress + particles
      tl.to(progressObj, {
        value: 100,
        duration: Math.max(0.6, durationMs / 1000),
        ease: "power2.inOut",
        onUpdate: () => {
          const p = Math.round(progressObj.value);
          const progress01 = Math.max(0, Math.min(1, p / 100));

          if (loadingFill) loadingFill.style.width = p + "%";
          if (percentage) percentage.textContent = p + "%";

          if (loadingGlow && loadingFill) {
            loadingGlow.style.opacity = 1;
            const fillW = loadingFill.offsetWidth || 0;
            loadingGlow.style.transform = `translateX(${Math.max(0, fillW - 35)}px)`;
          }

          if (loadingBarWrap && p % 2 === 0) {
            const r = loadingBarWrap.getBoundingClientRect();
            const x = r.left + r.width * progress01;
            const y = r.top + r.height / 2;

            // ui layer coords: absolute within overlay
            const rootRect = root.getBoundingClientRect();
            const lx = x - rootRect.left;
            const ly = y - rootRect.top;

            createTipSpark(gsap, lx, ly);
            createDustBurst(gsap, lx, ly);
          }
        }
      }, "-=0.5");

      tl.to({}, { duration: 0.45 });
      tl.to(container, { opacity: 0, duration: 1, ease: "power2.in" });

      if (skipBtn) {
        skipBtn.addEventListener("click", () => {
          try { tl.kill(); } catch(e){}
          markSeen();
          gsap.to(container, { opacity: 0, duration: 0.2, onComplete: cleanup });
        }, { once: true });
      }
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll(ROOT_SEL).forEach(initRoot);
  }

  if (document.readyState === "complete" || document.readyState === "interactive") boot(document);
  else document.addEventListener("DOMContentLoaded", () => boot(document));

  document.addEventListener("shopify:section:load", (e) => boot(e.target));
})();
